<template>
  <div>
    <v-btn
      :disabled="this.lastUpdatedInSeconds < 2"
      class="spin"
      color="info"
      size="small"
      variant="text"
      v-on:click.prevent="refreshTrackingData"
    >
      <img
        :alt="$t('overview.details.updated.description')"
        :src="publicPath(`/themes/${this.themeId}/icon_update.svg`)"
        class="update_icon"
      />
      <span class="text-link">{{
        $t('overview.details.updated.description')
      }}</span>
    </v-btn>

    <div class="text-footnote align-center">
      <span v-if="this.isUpdateAvailable">{{
        $t('overview.details.updateAvailable')
      }}</span>
      <span v-else-if="lastUpdatedInMinutes === 0">
        {{ $t('overview.details.updated.justNow') }}
      </span>
      <span v-else-if="lastUpdatedInMinutes === 1">
        {{ $t('overview.details.updated.oneMinute') }}
      </span>
      <span v-else-if="lastUpdatedInMinutes > 1">
        {{
          $t('overview.details.updated.minutes', lastUpdatedInMinutes, {
            named: {
              minutes: lastUpdatedInMinutes
            }
          })
        }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import publicPath from '@/util/publicPath';
import { useThemeStore } from '@/stores/theme.js';
import { useWebsocketStore } from '@/stores/websocket.js';
import { getUtmSource } from '@/router/queryParam.js';
import { useTrackingDataStore } from '@/stores/trackingData.js';
import { sendAnalytics } from '@/services/analytics.js';

let timer;

export default {
  name: 'LastUpdatedComponent',
  props: {
    updateTimestamp: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      lastUpdatedInMinutes: 0,
      lastUpdatedInSeconds: 0,
      refreshInterval: 2001
    };
  },
  computed: {
    ...mapState(useThemeStore, ['themeId']),
    ...mapState(useTrackingDataStore, {
      trackingData: 'data'
    }),
    ...mapState(useWebsocketStore, ['isUpdateAvailable'])
  },
  methods: {
    ...mapActions(useTrackingDataStore, [
      'updateTrackingWithTitleAndSessionUpdate'
    ]),
    publicPath,
    refreshTrackingData() {
      this.lastUpdatedInSeconds = 0;

      const analyticsName =
        this.trackingData.type === 'PRIVATE'
          ? 'tracking_page'
          : 'postcode_page';
      sendAnalytics(
        this.trackingData,
        'clickStats',
        `refresh_button_clicked_via_${analyticsName}`
      );

      this.updateTrackingWithTitleAndSessionUpdate(
        {
          utmSource: getUtmSource(this.$route),
          tenantId: this.$rttI18n.tenantId,
          trackingId: this.$route.params.trackingId,
          postcode: this.$route.params.postcode
        },
        true,
        this.$t
      );
    },
    setLastUpdated() {
      this.lastUpdatedInSeconds = (Date.now() - this.updateTimestamp) / 1000;
      this.lastUpdatedInMinutes = Math.floor(
        this.lastUpdatedInSeconds / 60,
        10
      );
    },
    updateInterval() {
      timer = setInterval(this.setLastUpdated, this.refreshInterval);
    }
  },
  mounted() {
    this.updateInterval();
  },

  beforeUnmount() {
    clearInterval(timer);
  }
};
</script>

<style scoped>
.spin img {
  transition: transform 0.3s ease-in-out;
}

.spin:hover img {
  transform: rotate(-360deg);
  transition: transform 0.7s ease-in-out;
}

.spin:disabled {
  opacity: 0.5;
  background-color: inherit !important;
}

.update_icon {
  margin-right: 0.5em;
}

div.text-footnote {
  margin-top: 0.5em;
  margin-bottom: 1em;
}
</style>
